import {  createSlice } from '@reduxjs/toolkit';


const initialState = {
  value: 0,
  status: 'idle',
};



export const userSlice = createSlice({
  name:'user',
  initialState:{
    user:null,
  },
  
 
  reducers: {
    login: (state, action) => {
      
      state.user = action.payload
    },
    logout: (state, action) => {
      state.user = null
    },
    
 
  },
 

});

export const { login,logout } = userSlice.actions;

//selectores
export const selectUser = (state) => state.user.user;



export default userSlice.reducer;
